import { isBefore, differenceInMonths } from 'date-fns';

import i18n from 'i18n';

import { TravelWalletFileKeys } from '../../TravelWallet/constansts';
import { i18nOptions } from './constants';

export const checkHasPassportExpirationDateWarning = (passportExpirationDate?: string, travelEndDate?: string) => {
  if (passportExpirationDate && travelEndDate) {
    const travelEnd = new Date(travelEndDate);
    const passportExpiration = new Date(passportExpirationDate);

    if (isBefore(passportExpiration, travelEnd) || travelEnd.toString() === passportExpiration.toString()) return true;

    if (isBefore(travelEnd, passportExpiration)) {
      const monthsBetween = differenceInMonths(passportExpiration, travelEnd);

      return monthsBetween < 6;
    }
  }

  return false;
};

/**
 *
 * using a getter for i18n because a constant cannot be initialized before the component renders
 * due to i18n not being initialized in time
 */
export const getTravelWalletDocumentsLocalisation = () => ({
  [TravelWalletFileKeys.insuranceDocuments]: i18n.t('files.types.files', i18nOptions),
  [TravelWalletFileKeys.guestMiscDocuments]: i18n.t('files.types.files', i18nOptions),
  [TravelWalletFileKeys.passportDocuments]: i18n.t('files.types.passport', i18nOptions),
});
